import { RootState } from "../index";
import { createDraftSafeSelector } from "@reduxjs/toolkit";

const selectAppReducer = (state: RootState) => state;

export const selectEdmProducts = createDraftSafeSelector(
  selectAppReducer,
  (state) => state.dEdmProducts,
);

export const selectFilters = createDraftSafeSelector(
  selectEdmProducts,
  (state) => state.filters,
);

export const selectSearchName = createDraftSafeSelector(
  selectFilters,
  (state) => state.name,
);

export const selectPaginationObject = createDraftSafeSelector(
  selectEdmProducts,
  (state) => state.pagination,
);

export const selectTableData = createDraftSafeSelector(
  selectEdmProducts,
  (state) => state.data,
);

export const selectDetailItemId = createDraftSafeSelector(
  selectEdmProducts,
  (state) => state.detailItemId,
);
